const base = `${process.env.PUBLIC_URL || ''}/panneaux`;

export const PANEL_IMAGES = {
  deroulant: `${base}/deroulant.webp`,
  led: `${base}/led.webp`,
  grand_format: `${base}/grand_format.webp`,
  poteau: `${base}/poteau.webp`,
};

const ALIASES = {
  'panneau déroulant': 'deroulant', 'déroulant': 'deroulant', deroulant: 'deroulant',
  'panneau led': 'led', led: 'led',
  'grand format': 'grand_format', grand_format: 'grand_format', grand: 'grand_format',
  'panneau poteau': 'poteau', poteau: 'poteau',
};

export const panelImage = (type) => PANEL_IMAGES[ALIASES[String(type || '').toLowerCase().trim()]] || PANEL_IMAGES.deroulant;

export function PanelImage({ type, className = '', alt, testid }) {
  return (
    <img src={panelImage(type)} alt={alt || `Panneau ${type}`} loading="lazy" draggable={false}
      className={`object-contain select-none mix-blend-multiply ${className}`} data-testid={testid} />
  );
}
